import { Badge, Breadcrumb, Button, Calendar, Checkbox, Col, DatePicker, Divider, Drawer, Dropdown, Flex, Form, Input, Layout, notification, Radio, Row, Select, Space, Table, Tag, theme } from 'antd';
import {
  SendOutlined,
  MoreOutlined,
  MessageOutlined,
  UnlockOutlined,
  EyeOutlined,
  LockOutlined,
  EditOutlined
} from '@ant-design/icons';
import React, { useEffect, useRef, useState } from 'react';
import TextArea from 'antd/es/input/TextArea';
import CalendarDataAPI from '../../../restAPI/CalendarDataAPI';
import MeetingsAPI from '../../../restAPI/MeetingAPI';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import moment, { duration } from 'moment-timezone';
import useCurrentCompany from '../../../hooks/useCurrentCompany';

const { Search } = Input;
const { Header, Sider, Content } = Layout;


const options = [
  // Bug 14545 - fixes
  {
    label: 'Attend',
    value: 'yes',
  },
  {
    label: 'May Be',
    value: 'maybe',
  },
  {
    label: 'Not Attend',
    value: 'no',
  },
];
export default function MyResponse(props) {

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  const { companyId, token, userCompany } = useSelector(state => state.auth);

  const [form] = Form.useForm();

  // const [value, setValue] = useState('yes');
  const [value, setValue] = useState(props.actionStep === 'add' ? '' : props.attendanceStatus?.toLowerCase());
  const [showTextArea, setShowTextArea] = useState(false);
  const [isSearchingALTsignatoty, setIsSearchingALTsignatoty] = useState(false);
  const [rsvpResponse, setRsvpResponse] = useState({
    type: '',
    altSignatory: false,
    comment: ''
  });
  const [altSignatoryDetails, setAltSignatoryDetails] = useState(null);  
  const currentCompanyInfo = useCurrentCompany();
  const [isSignatoryChecked, setIsSignatoryChecked] = useState(
    props.actionStatus !== 'add' ? props.participants?.member?.signatoryStatus : false
  );
  const [sendButtonLoading, setSendButtonLoading] = useState(false);

  const [api, contextHolder] = notification.useNotification();

  const openNotificationWithIcon = (type, message, description, placement) => {
    api[type]({
      message: message,
      description: description,
      placement,
      duration
    });
  };

  const onChange = ({ target: { value } }) => {
    setValue(value);
  };

  const onChangeSignatory = (e) => {
    setShowTextArea(e.target.checked);
  };

  

  useEffect(() => {
    if (props.participants && props.actionStep !== 'add') {
      setShowTextArea(props.participants.member.signatoryStatus);
      form.setFieldsValue({ comment: props.participants.member.comment });
      setIsSignatoryChecked(props.participants.member.signatoryStatus)
    }
  }, [props.actionStep, value]);

  useEffect(() => {
    if (props.actionStep === 'add') {
      setShowTextArea(false);
      form.resetFields(['comment']);
      setRsvpResponse(prev => ({
        ...prev,
        altSignatory: false,
        comment: ''
      }));
    }
  }, [value]);

  useEffect(() => {
    if (!showTextArea) {
      setRsvpResponse(prev => ({
        ...prev,
        altSignatory: false,
        comment: ''
      }));
    }
  }, [showTextArea]);

  const getAvailableSignatory = async () => {
    const newPayload = {
      userId: currentCompanyInfo.userDetailsId,
      meetingsDetails: [{
        meetingId: props.meetingFullData.meeting._id,
        meetingStartDateTime: props.meetingFullData.meeting.info.startDate,
        meetingEndDateTime: props.meetingFullData.meeting.info.endDate,
        meetingOriginalDate: props.meetingFullData.meeting.originalDate
      }]
    };

    try {
      setIsSearchingALTsignatoty(true);
      const res = await MeetingsAPI.getAvailableSignatory(newPayload, companyId, token);
      setAltSignatoryDetails(res.data || []);
    } catch (error) {
      console.log("Error in getAvailableSignatory :", error);
      openNotificationWithIcon('error', 'Failed', `Failed to get alternative signatory details.`, 'bottomLeft');
    } finally {
      setIsSearchingALTsignatoty(false);
    }
  };

  const handleSubmit = async () => {
    try {
      setSendButtonLoading(true);
      // if (props.participants.member.type !== 'signatory') {
        const participantId = props.meetingFullData?.meeting?.participant?._id || '';

        let transformedResponse = {
          rsvp: {
            type: rsvpResponse.type || 'yes',
            signatory: rsvpResponse.altSignatory || false,
            comment: rsvpResponse.comment || ''
          }
        };

        if (rsvpResponse.type === 'no' && rsvpResponse.altSignatory) {
          const { originalDate, meetingDate, meeting: { _id: meetingId, info: { name, startDate, endDate }, committeeId } } = props.meetingFullData;

          transformedResponse = {
            ...transformedResponse,
            details: [{
              meetingId: meetingId || '',
              meetingName: name || '',
              meetingOriginalDate: originalDate || '',
              meetingDate: meetingDate || '',
              meetingStartDateTime: startDate || '',
              meetingEndDateTime: endDate || '',
              committeeId: committeeId || '',
              signatoryId: altSignatoryDetails[0]?.signatoryId || ''
            }]
          };
        }

        console.log('transformedResponse :', transformedResponse)

        const response = await MeetingsAPI.updateParticipantRsvpById(participantId, transformedResponse, companyId, token);
        console.log('RSVP save response : ',response)
        if (response.status === 200) {
          openNotificationWithIcon('success', 'Successful', `${response.data.message}`, 'bottomLeft', 3);
          // openNotificationWithIcon('success', 'Successful', `RSVP status changed successfully.`, 'bottomLeft');
          setTimeout(() => {
            props.closeDrawer();
            setSendButtonLoading(false)
          }, 1500);
        }
        else {
          setSendButtonLoading(false)
          openNotificationWithIcon('error', 'Response adding failed', `${response.data.message}`, 'bottomLeft');
        }
      // }
      // else {
      //   openNotificationWithIcon('error', 'Response adding failed', `Signatory can't change RSVP.`, 'bottomLeft');
      // }

    } catch (error) {
      setSendButtonLoading(false)
      if (error.response) {
        openNotificationWithIcon('error', 'Response adding failed', `${error.response.data.message}`, 'bottomLeft');
      } else {
        openNotificationWithIcon('error', 'Response adding failed', `${error.message}`, 'bottomLeft');
      }
      console.log("Error in updateParticipantRsvpById :", error);
    }
  };

  const handleRadioChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);

    setRsvpResponse((prev) => ({
      ...prev,
      type: newValue
    }));

    if (newValue === 'no') {
      setIsSignatoryChecked(false);
      setShowTextArea(false);
      setAltSignatoryDetails(null);
      form.resetFields(['comment']);
    }
  };

  return (
    <>
      <Form form={form}>
        <Form.Item name='responseType'>
          <center>
            {/* Bug 14545 - fixes */}
            <Radio.Group buttonStyle="solid" options={options}
              // onChange={(e) => {
              //     setValue(e.target.value);
              //     setRsvpResponse(prev => ({
              //         ...prev,
              //         type: e.target.value
              //     }))
              // }}
              onChange={(e) => handleRadioChange(e)}
              block
              size='large'
              value={value} optionType="button" />
          </center>
        </Form.Item>
        {/* {value === 'no' && (
          <Form.Item name='signatory'>
            <Checkbox
              checked={isSignatoryChecked}
              onChange={(e) => {
                const checked = e.target.checked;
                setIsSignatoryChecked(checked);

                setShowTextArea(checked);
                if (checked) {
                  getAvailableSignatory();
                }
                if (!checked) {
                  form.resetFields(['comment']);
                }

                setRsvpResponse(prev => ({
                  ...prev,
                  altSignatory: checked
                }));
              }}
              disabled={props.actionStep === 'edit' && props.attendanceStatus?.toLowerCase() === 'no'}
            >
              Alternative Signatory
            </Checkbox>
          </Form.Item>
        )} */}
        {(showTextArea && value === 'no') && (
          <>
            <Form.Item name='signatoryName'>
              <Content>
                <span>{(props.actionStep === 'add' || props.attendanceStatus?.toLowerCase() !== 'no') ? "Most available signatory " : "Selected signatory "}</span><br />
                <span>{
                  (props.actionStep === 'add' || props.attendanceStatus?.toLowerCase() !== 'no') ? isSearchingALTsignatoty ?
                    'Searching...' : altSignatoryDetails && altSignatoryDetails.length > 0 ? altSignatoryDetails[0].signatoryName
                      : 'No available signatory'
                    : (props.participants?.member?.signatoryName || "Not selected")
                }
                </span>
              </Content>
            </Form.Item>
            <Form.Item name='comment'>
              <TextArea placeholder='Add your Note' onChange={(e) => {
                setRsvpResponse(prev => ({
                  ...prev,
                  comment: e.target.value
                }));
              }}
                disabled={props.actionStep === 'edit' && props.attendanceStatus?.toLowerCase() === 'no'}
              />
            </Form.Item>
          </>
        )}
        <Form.Item>
          <Button type="primary" block onClick={handleSubmit}
            disabled={
              (rsvpResponse.type.length === 0)
              || value === props.attendanceStatus?.toLowerCase()
              || (value === 'no' && isSignatoryChecked && altSignatoryDetails && altSignatoryDetails.length === 0)}
              loading={sendButtonLoading}
          >
            Save
          </Button>
        </Form.Item>
      </Form>
      {contextHolder}
    </>
  );
}